"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckOrdersModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dialog_1 = require("primereact/dialog");
const react_i18next_1 = require("react-i18next");
const FiltersComponent_1 = require("../../../components/filter/FiltersComponent");
const GenericButton_1 = require("../../../components/web-view/button/GenericButton");
const useIsMobile_1 = require("../../../hooks/mobile/useIsMobile");
const toastContext_1 = require("../../../context/toast/toastContext");
const PadelLoading_1 = require("../../../components/loader/PadelLoading");
const CheckOrdersModal = ({ visible, onConfirm, onCancel, handlerDateFilter, startTs, endTs, loading, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { toastRef } = (0, toastContext_1.useToastContext)();
    const onCheckOrders = async () => {
        if (startTs && endTs) {
            try {
                await onConfirm();
            }
            catch (error) {
                console.error('Error en confirmación:', error);
            }
        }
        else {
            toastRef.current?.show({
                severity: 'warn',
                summary: t('warning'),
                detail: t('selectDateRange'),
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)(dialog_1.Dialog, { visible: visible, onHide: onCancel, header: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: t('checkOrders') }), ' '] }), className: `${isMobile ? 'w-[98%] p-0' : 'w-[40vw]'} montserratMedium`, draggable: false, dismissableMask: true, closable: true, showHeader: true, contentClassName: 'w-full h-full p-0', children: (0, jsx_runtime_1.jsx)("div", { className: "w-full p-d-flex p-ai-center p-jc-center", style: { height: '100%' }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                    width: '100%',
                    height: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }, children: [(0, jsx_runtime_1.jsxs)("div", { className: `${isMobile ? 'w-full' : 'w-3/4'} flex justify-center items-center mt-4 mb-2 `, children: [loading && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: `absolute inset-0 flex justify-center items-center z-50`, style: { backgroundColor: 'rgb(66 69 81 / 19%)' }, children: (0, jsx_runtime_1.jsx)(PadelLoading_1.PadelLoading, {}) }) })), (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { handlerDateFilter: handlerDateFilter, resetPageToFirst: () => { }, maxRangeInMonths: 1 })] }), (0, jsx_runtime_1.jsxs)("div", { className: "w-full flex justify-center items-center gap-2 mt-10 mb-4", children: [(0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { label: t('cancel'), onClick: onCancel }), (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { label: t('generate'), onClick: onCheckOrders })] })] }) }) }));
};
exports.CheckOrdersModal = CheckOrdersModal;
